import { render } from "./Dossier.vue?vue&type=template&id=aeca0620&ts=true"
import script from "./Dossier.vue?vue&type=script&lang=ts"
export * from "./Dossier.vue?vue&type=script&lang=ts"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__